import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-discussions',
  templateUrl: './discussions.component.html',
  styleUrls: ['./discussions.component.sass']
})
export class DiscussionsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
